module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top-menu"
  }, [_c('sporte-menu'), _vm._v(" "), (_vm.user.authenticated) ? _c('el-row', {
    staticClass: "menu bottom-menu"
  }, [_c('subheader')], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "view-container",
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-729d1dec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 426
// module chunks = 23